const KOLKATA_TIMEZONE = "Asia/Kolkata";

function getDateParts(value = new Date()) {
  const formatter = new Intl.DateTimeFormat("en-GB", {
    timeZone: KOLKATA_TIMEZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });

  const parts = formatter.formatToParts(new Date(value));

  return Object.fromEntries(parts.filter((item) => item.type !== "literal").map((item) => [item.type, item.value]));
}

export function getKolkataHour(value = new Date()) {
  return Number(getDateParts(value).hour || 0);
}

export function getKolkataMonthDay(value = new Date()) {
  const parts = getDateParts(value);
  return `${parts.month}-${parts.day}`;
}

export function formatKolkataDate(value) {
  if (!value) return "-";

  return new Intl.DateTimeFormat("en-IN", {
    timeZone: KOLKATA_TIMEZONE,
    year: "numeric",
    month: "short",
    day: "numeric",
  }).format(new Date(value));
}

export function formatKolkataDateTime(value) {
  if (!value) return "-";

  return new Intl.DateTimeFormat("en-IN", {
    timeZone: KOLKATA_TIMEZONE,
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  }).format(new Date(value));
}

export { KOLKATA_TIMEZONE };
